var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embedded"},[(_vm.card)?_c('Card',{key:_vm.card.id,attrs:{"embedded":true,"card":_vm.card,"layer":_vm.card.layer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }